import styled from 'styled-components';

export const ScrollContainer = styled.div`
  float: left;
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  overflow-y: auto;
`;

export const ScrollContent = styled.div`
  width: 100%;
  float: left;
  height: auto;
`;
